<div class="loader-overlay" >
    <div class="loader-wrapper">
      <mat-spinner id="matSpinner" class="spinner" mode="indeterminate" diameter="64"></mat-spinner>
    </div>
</div>
